module.exports = __webpack_public_path__ + "img/logo_texto_light.4a152527.png";